import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NavActions {
  private readonly _hideNav: WritableSignal<boolean> = signal(true);
  readonly current = this._hideNav.asReadonly();
  private readonly _expand: WritableSignal<string> = signal('');
  readonly expand = this._expand.asReadonly();

  expandMenu = (key: string) => {
    if (this.expand() === key) {
      this._expand.set('');
    } else {
      this._expand.set(key);
    }
  }

  toggle = (visible: boolean) => {
    this._hideNav.set(visible);
  }
}
